import React from "react";
import { Link } from "react-router-dom";
import { FiShoppingCart, FiBell, FiChevronDown } from "react-icons/fi";
import { FaWallet } from "react-icons/fa";

function HeaderDashboard() {
  const remediesMenu = [
    { name: "Gems", link: "/remedies/gems" },
    { name: "Pooja", link: "/remedies/pooja" },
    { name: "Yantra", link: "/remedies/yantra" },
  ];
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 py-[5px] bg-white border-b border-gray-100">
        <div className="drawer">
          <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
          <div className="drawer-content flex flex-col">
            {/* Navbar */}
            <div className="navbar p-0 w-full">
              <div className="container">
                <div className="header-inner-dark flex items-center gap-[15px] w-full p-0">
                  <div className="head-left flex items-center gap-[15px]">
                    <div className="flex-none lg:hidden">
                      <label
                        htmlFor="my-drawer-3"
                        aria-label="open sidebar"
                        className="btn btn-square btn-ghost p-0 !flex !items-center !justify-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          className="inline-block h-6 w-6 stroke-current"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            stroke="#000"
                            d="M4 6h16M4 12h16M4 18h16"
                          ></path>
                        </svg>
                      </label>
                    </div>

                    <Link to="/" className="logo">
                      <img
                        src="/images/logo.svg"
                        alt="logo"
                        className="max-w-[120px] lg:max-w-[177px]"
                      />
                    </Link>
                  </div>

                  <div className="hidden head-right lg:flex items-center gap-[15px] flex-1">
                    <ul className="menu menu-horizontal m-0 flex-1 flex items-center gap-[10px] justify-center">
                      <li>
                        <Link
                          to="/user"
                          className="web-h6 !text-gray-700 hover:!text-gray-900 !no-underline"
                        >
                          Dashboard
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/consultation"
                          className="web-h6 !text-gray-700 hover:!text-gray-900 !no-underline"
                        >
                          Astrologer Consultation
                        </Link>
                      </li>
                      <li>
                        <details>
                          <summary className="web-h6 !text-gray-700 hover:!text-gray-900 flex items-center gap-1">
                            Remedies
                          </summary>
                          <ul className="p-2 bg-white rounded-box shadow min-w-[180px]">
                            {remediesMenu.map((m) => (
                              <li key={m.name}>
                                <Link
                                  to={m.link}
                                  className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                                >
                                  {m.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </details>
                      </li>
                      <li>
                        <Link
                          to="/user/orders"
                          className="web-h6 !text-gray-700 hover:!text-gray-900 !no-underline"
                        >
                          My Orders
                        </Link>
                      </li>
                    </ul>
                    <ul className="flex items-center gap-[12px] m-0">
                      <li>
                        <button className="">
                          <img src="/images/cart.svg" alt="cart" />
                        </button>
                      </li>
                      <li>
                        <button className="">
                          <img src="/images/bell.svg" alt="bell" />
                        </button>
                      </li>
                      <li>
                        <Link
                          to="/user/wallet"
                          className="h-9 px-3 web-h6 rounded-full border-[#FAF5C7] border-[1px] bg-primary-50 text-primary-500 flex items-center gap-2 !no-underline"
                        >
                          <img src="/images/wallet.svg" alt="wallet" />
                          <span className="medium text-[14px]">Wallet</span>
                        </Link>
                      </li>
                      <li>
                        <div className="dropdown dropdown-end">
                          <div
                            tabIndex={0}
                            role="button"
                            className="flex items-center gap-2"
                          >
                            <img
                              src="/images/user1.png"
                              alt="user"
                              className="w-[36px] h-[36px] rounded-full object-cover"
                            />
                            <span className="web-h6 text-gray-950">
                              Acharya Vivek
                            </span>
                            <img src="/images/drop-arrow.svg" />
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content menu bg-white rounded-box shadow w-56 p-2 mt-2"
                          >
                            <li>
                              <Link
                                to="/user/profile"
                                className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                              >
                                Profile
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/user/orders"
                                className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                              >
                                My Orders
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/user/orders"
                                className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                              >
                                Logout
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="drawer-side">
            <label
              htmlFor="my-drawer-3"
              aria-label="close sidebar"
              className="drawer-overlay"
            ></label>
            <ul className="menu bg-base-200 min-h-full flex flex-col gap-[5px] w-80 p-4">
              {/* Sidebar content */}
              <li>
                <Link
                  to="/user"
                  className="web-h6 text-black hover:no-underline bold"
                >
                  Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/consultation"
                  className="web-h6 text-black hover:no-underline bold"
                >
                  Astrologer Consultation
                </Link>
              </li>
              <li>
                <details open>
                  <summary className="web-h6 text-black hover:no-underline bold after:hidden">
                    Remedies
                  </summary>
                  <ul>
                    {remediesMenu.map((m) => (
                      <li key={m.name}>
                        <Link
                          to={m.link}
                          className="web-h6 text-black hover:no-underline bold"
                        >
                          {m.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </details>
              </li>
              <li>
                <Link
                  to="/user/orders"
                  className="web-h6 text-black hover:no-underline bold"
                >
                  My Orders
                </Link>
              </li>
              <li>
                <div className="dropdown dropdown-end">
                  <div
                    tabIndex={0}
                    role="button"
                    className="flex items-center gap-2"
                  >
                    <img
                      src="/images/user1.png"
                      alt="user"
                      className="w-[36px] h-[36px] rounded-full object-cover"
                    />
                    <span className="web-h6 text-gray-950">Acharya Vivek</span>
                    <img src="/images/drop-arrow.svg" />
                  </div>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu bg-white rounded-box shadow w-56 p-2 mt-2"
                  >
                    <li>
                      <Link
                        to="/user/profile"
                        className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                      >
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/user/orders"
                        className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                      >
                        My Orders
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/user/orders"
                        className="!no-underline web-h6 !text-gray-700 hover:!text-gray-900"
                      >
                        Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
}

export default HeaderDashboard;
